export default function getResource(label) {
    const resources = {
        NoResultsTitle: 'We could not find any results.',
        NoResultsBody: 'Please retake the quiz above or explore other quizzes below.'
    };
    return resources[label];
}

